import Button from 'blocks/Button';
import StatusText from 'blocks/StatusText';
import RouteDetail from 'components/Flight/RouteDetail';
import BaseModal from 'components/modals/BaseModal';
import { FlightTransaction } from 'pages/miles/View/viwe.interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentProps } from './flightTransactionDetail.interface';
import * as S from './flightTransactionDetailModal.styles';

const Content = ({ open, closeModal, flight }: ContentProps) => {
  const { t } = useTranslation();
  if (!flight) return null;

  return (
    <S.FlightDetailModal>
      <S.GrayCard>
        <RouteDetail flight={flight} showPNR />
      </S.GrayCard>

      <S.BtnContainer>
        <StatusText color={flight.status === 'pending' ? 'warn' : flight.status === 'registered' ? 'success' : 'error'}>
          {flight.status}
        </StatusText>

        <S.Btn as={Button} styleType="default" className="fs-xs" onClick={closeModal}>
          {t('pages.miles.view.modals.details.closeCTA')}
        </S.Btn>
      </S.BtnContainer>
    </S.FlightDetailModal>
  );
};

interface State {
  open: boolean;
  flight: FlightTransaction | null;
}

interface Props {
  ref: any;
}

class FlightDetailTransactionModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      flight: null,
    };
  }

  openModal = (flight: FlightTransaction): void => this.setState({ open: true, flight });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.FlightDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.flight ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} flight={this.state.flight} />
        ) : null}
      </S.FlightDetailModalContainer>
    );
  }
}

export default FlightDetailTransactionModal;
